import React, { useRef, useEffect, useState } from 'react'
import {
  NavBar,
  NavTabTitle,
  Link,
  VisibleMenu,
  HiddenMenu,
  DropDownMenu,
  DropDownButton,
  CaretDown,
} from './styles'
import type { ConnectorProps as ListProps } from '../../connectors/Collection'
import CollectionConnector from '../../connectors/Collection'
import { DEFAULT_URL, DEFAULT_URL_WITH_TRAILING_SLASH } from '../../helpers/constants'



// Get an ARRAY of Elements width => [84, 150, 240, ...]
const getElementsWidth = (parent) => {
  const widthCache = []
  parent.childNodes.forEach((child) => widthCache.push(child.offsetWidth || 0))
  return widthCache
}

// We need to say what ELEMENTS are ON/OFF screen ( VISIBLE or NOT )
const sortItems = ({ containerWidth, elementCache, updateOnScreen, updateOffScreen }) => {
  const onScreen = []
  const offScreen = []
  let totalWidth = 0
  elementCache.forEach((width, index) => {
    if (totalWidth + width < containerWidth) {
      onScreen.push(index)
    } else {
      offScreen.push(index)
    }

    totalWidth += width
  })
  updateOnScreen(onScreen)
  updateOffScreen(offScreen)
}

export default CollectionConnector(
  (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const {
      updateCollectionTypeUrl,
      screenWidth,
      collectionTypes,
      pageSlugifyDictionary,
      pagePath,
    } = props
    const menu: Record<string, any> = useRef(null)
    const [elementCache, updateElementCache] = useState()
    const [onScreen, updateOnScreen] = useState([...Array(collectionTypes.length).keys()]) // Render all ITEMS first time

    const [offScreen, updateOffScreen] = useState([]) // Empty Initially

    const dropdownRef: Record<string, any> = useRef(null)
    const [isActive, setIsActive] = useState(false)

    const onClickMore = () => setIsActive(!isActive)

    useEffect(() => {
      if (screenWidth > 1024) {
        if (menu.current) {
          const { offsetWidth: containerWidth } = menu.current

          // Lets Create a Cache of Elemets ( ONLY needed once )
          if (!elementCache) {
            const cache = getElementsWidth(menu.current)
            updateElementCache(cache) // Now we will have for every ReRender

            sortItems({
              containerWidth,
              elementCache: cache,
              updateOnScreen,
              updateOffScreen,
            })
          } else {
            sortItems({
              containerWidth,
              elementCache,
              updateOnScreen,
              updateOffScreen,
            })
          }
        }
      }
    }, [screenWidth])
    // Any Screen Resize
    useEffect(() => {
      const pageClickEvent = (e) => {
        // If the active element exists and is clicked outside of
        if (dropdownRef.current !== null) {
          setIsActive(!isActive)
        }
      }

      // If the item is active (ie open) then listen for clicks
      if (isActive) {
        window.addEventListener('click', pageClickEvent)
      }

      return () => {
        window.removeEventListener('click', pageClickEvent)
      }
    }, [isActive])

    const getUrlValueFromDictionary = (section) => {
      return pageSlugifyDictionary[section]
    }

    const getPagePathValue = (pagePathValue) => {
      const pagePathSplitArray = pagePathValue.split('/')

      if (pagePathValue === DEFAULT_URL || pagePathValue === DEFAULT_URL_WITH_TRAILING_SLASH) {
        return getUrlValueFromDictionary(collectionTypes[0])
      } else if (pagePathSplitArray.length > 2) {
        return pagePathSplitArray[pagePathSplitArray.length - 1]
      } else {
        return pagePathValue
      }
    }

    return (
      <NavBar>
        <VisibleMenu ref={menu}>
          {onScreen.map((section, index) => (
            <NavTabTitle key={index} itemProp='name'>
              <Link // href={href}
                itemProp='url'
                title={`See ${collectionTypes[section]} collections`}
                data-active={
                  getUrlValueFromDictionary(collectionTypes[section]) === getPagePathValue(pagePath)
                }
                onClick={(ev) => {
                  ev.preventDefault()
                  updateCollectionTypeUrl(getUrlValueFromDictionary(collectionTypes[section]))
                }}
              >
                <p className='defaultTypographyCtaLarge'>{collectionTypes[section]}</p>
              </Link>
            </NavTabTitle>
          ))}
        </VisibleMenu>
        <DropDownMenu>
          {offScreen.length > 0 && (
            <DropDownButton onClick={onClickMore}>
              <p className='defaultTypographyCtaLarge'>
                <div data-type='tabs-more-container'>
                  More
                  <CaretDown />
                </div>
              </p>
            </DropDownButton>
          )}
          <HiddenMenu ref={dropdownRef} data-type={isActive ? 'active' : ''}>
            {offScreen.map((section, index) => (
              <NavTabTitle key={index} itemProp='name'>
                <Link // href={href}
                  itemProp='url'
                  title={`See ${collectionTypes[section]} collections`}
                  data-active={
                    getUrlValueFromDictionary(collectionTypes[section]) ===
                    getPagePathValue(pagePath)
                  }
                  onClick={(ev) => {
                    ev.preventDefault()
                    updateCollectionTypeUrl(getUrlValueFromDictionary(collectionTypes[section]))
                  }}
                >
                  <p className='defaultTypographyCtaLarge'>{collectionTypes[section]}</p>
                </Link>
              </NavTabTitle>
            ))}
          </HiddenMenu>
        </DropDownMenu>
        <div data-type='line' />
      </NavBar>
    )
  }
)
